import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'

export const FooterRow = forwardRef((props, ref) => {
  const { as = 'div', children, ...rest } = props
  const Comp = as
  return (
    <Comp className="dev_dash__footer-row" ref={ref} {...rest}>
      {children}
    </Comp>
  )
})

FooterRow.displayName = 'FooterRow'

FooterRow.propTypes = {
  as: PropTypes.any,
  children: PropTypes.any.isRequired,
}
